import {create} from 'zustand';
import {
  PAGE_TYPE,
  type MetaDataState,
  type PatientInformation,
} from '../constants/types';

interface GuestPortalStore {
  // State
  pageType: PAGE_TYPE;
  metaData: MetaDataState;
  referenceCode: string;
  patientInformation: PatientInformation;
  confirmLeavePageModal: boolean;
  contactSupportModal: boolean;

  // Actions
  setPageType: (pageType: PAGE_TYPE) => void;
  setMetaData: (metaData: MetaDataState) => void;
  setReferenceCode: (referenceCode: string) => void;
  setPatientInformation: (patientInformation: PatientInformation) => void;
  setConfirmLeavePageModal: (open: boolean) => void;
  setContactSupportModal: (open: boolean) => void;
}

export const useGuestPortalStore = create<GuestPortalStore>(set => ({
  // Initial state
  pageType: PAGE_TYPE.LOGIN,
  metaData: {
    orderId: undefined,
    clientId: undefined,
    relyingPartyId: undefined,
    documentType: undefined,
    providerName: undefined,
    uploadedBy: undefined,
    consumerUuid: undefined,
    userComment: undefined,
  },
  referenceCode: '',
  patientInformation: {
    patientFirstName: undefined,
    patientLastName: undefined,
    patientDateOfBirth: undefined,
    requestedMedicalRecordsType: undefined,
    recordsRequestedDateFrom: undefined,
    recordsRequestedDateTo: undefined,
    recordsIsMaximumDateRange: undefined,
  },
  confirmLeavePageModal: false,
  contactSupportModal: false,

  // Actions
  setPageType: pageType => set({pageType}),
  setMetaData: metaData => set({metaData}),
  setReferenceCode: referenceCode => set({referenceCode}),
  setPatientInformation: patientInformation => set({patientInformation}),
  setConfirmLeavePageModal: confirmLeavePageModal =>
    set({confirmLeavePageModal}),
  setContactSupportModal: contactSupportModal => set({contactSupportModal}),
}));
